<template>
    <div class="product-assignments constrain flex">
        <div class="ff">
            <!-- <div class="flex product-search">
                <input type="text" placeholder="Search Book..." v-model="search" class="search" @input="filter" />
                <div class="ff"></div>
            </div> -->
            <div class="assignments" v-if="assignments.length">
                <div class="flex flex-align assignment" v-for="assignment of assignments" :key="assignment.assignment_id">
                    <div class="number">{{assignment.chapter_number}}</div>
                    <div class="ff">
                        <router-link class="title" :to="{name: 'assignment', params: {assignment: assignment.assignment_id}}">{{assignment.chapter_title}}</router-link>
                        <div class="assignment-course">{{assignment.course.name}}</div>
                    </div>
                    <div class="flex flex-column assignment-options">
                        <template v-if="product.license_type === 'teacher'">
                            <!-- TODO There's an error in logic here where the user might have a teacher license but they're not a teacher of the course in Canvas, etc. -->
                            <a class="assignment-delete pointer" @click="remove(assignment)">Delete</a>
                            <div class="assignment-due text-right">
                                Due {{assignment.assignment_due_date | pretty('date')}} at {{assignment.assignment_due_date | pretty('time')}}
                            </div>
                        </template>
                        <template v-else>
                            <div class="assignment-state text-right" :class="assignment.submission_state">
                                {{state(assignment)}}
                            </div>
                            <div class="assignment-due text-right" v-if="assignment.submission_state === 'submitted'">
                                {{assignment.submission_score}} Point{{assignment.submission_score === 1 ? '' : 's'}}
                            </div>
                            <div class="assignment-due text-right" v-else>
                                Due {{assignment.assignment_due_date | pretty('date')}} at {{assignment.assignment_due_date | pretty('time')}}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div v-else class="nothing">
                You have not {{product.license_type === 'student' ? 'been' : ''}} assigned any exercises.
            </div>
        </div>
        <product-metadata :product="product" />
    </div>
</template>

<script>
    import Options from '@/components/modals/Options.vue';

    export default {
        name: 'ProductAssignments',
        data(){
            return {
                loading: true,
                search: '',
                assignments: []
            };
        },
        methods: {
            filter(){

            },
            state(assignment){
                if(assignment.submission_state){
                    const states = {
                        started: 'Started',
                        submitted: 'Turned In'
                    };

                    return states[assignment.submission_state];
                }else{
                    return 'Not Started';
                }
            },
            remove(assignment){
                const _this = this;

                this.$modal.show(Options, {
                    options: [
                        {
                            color: 'red',
                            title: 'Delete Assignment',
                            fn(){
                                _this.$http.delete(`/products/${_this.product.product_id}/assignments/${assignment.assignment_id}`)
                                .then(response => {
                                    _this.$toasted.success('The assignment has been deleted.');
                                    _this.assignments.splice(_this.assignments.indexOf(assignment), 1);
                                })
                                .catch(error => _this.$toasted.error('There was an error loading the product contents.'));
                            }
                        }
                    ]
                },
                {
                    width: 260,
                    height: 'auto',
                    classes: 'modal'
                });
            }
        },
        computed: {
            product(){
                return this.$store.getters.product;
            }
        },
        created(){
            if(this.product){
                this.$http.get(`/products/${this.product.product_id}/assignments`)
                .then(response => this.assignments = response.$data)
                .catch(error => this.$toasted.error('There was an error loading the product contents.'))
                .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @section-font-size: 24px;
    @number-width: 40px;

    .product-assignments
    {
        padding: 50px;
    }

    .product-search
    {
        padding-bottom: 25px;
    }

    .search
    {
        max-width: 400px;
    }

    .product
    {
        padding: 40px 50px;

        .toc
        {
            // padding-top: 50px;
        }
    }

    .assignment
    {
        padding: 4px 0;
        line-height: 24px;
        margin-bottom: 15px;

        .number
        {
            width: @number-width;
            font-size: 15px;
            color: var(--secondary-text-color);
            position: absolute;
            left: -40px;
            top: 4px;
        }

        .title
        {
            cursor: pointer;
            font-size: 15px;
            color: var(--primary-text-color);

            &::after
            {
                content: "";
                position: absolute;
                border-bottom: 1px solid var(--secondary-text-color);
                top: 0;
                left: 0;
                bottom: -2px;
                pointer-events: none;
                width: 0;
                transition: width ease 0.2s;
            }

            &:hover, &:active
            {
                &::after
                {
                    width: 100%;
                }
            }
        }

        .questions-icon, .simulations-icon
        {
            width: 24px;
            height: 24px;
            opacity: 0.2;

            &.active
            {
                opacity: 1;
            }
        }

        .questions-icon
        {
            background: url('~@/assets/icons/grey/questions.svg') 5px 7px no-repeat;
            background-size: 14px auto;
        }

        .simulations-icon
        {
            background: url('~@/assets/icons/grey/simulations.svg') 2px 7px no-repeat;
            background-size: 22px auto;
        }

        .text-button
        {
            margin-right: 10px;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;
            height: 24px;
        }
    }

    .assignment-course
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 16px;
        margin-top: 2px;
    }

    .assignment-state
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 18px;

        &.started
        {
            color: var(--primary-text-color);
        }

        &.submitted
        {
            color: @base;
        }
    }

    .assignment-delete
    {
        font-size: 13px;
        line-height: 18px;
        color: @red;
        transition: opacity ease 0.2s;

        &:hover, &:active
        {
            opacity: 0.7;
        }
    }

    .assignment-options
    {
        align-items: flex-end;
    }

    .assignment-due
    {
        font-size: 12px;
        color: var(--secondary-text-color);
        line-height: 16px;
    }
</style>